export const VisualBuilderDeviceList = ["mobile", "desktop"] as const;
export type VisualBuilderDevice = (typeof VisualBuilderDeviceList)[number];

export interface VisualBuilderViewport {
  name: VisualBuilderDevice;
  width: number;
  height: number;
}

export const VisualBuilderViewports = {
  mobile: { name: "mobile", width: 390, height: 844 },
  desktop: { name: "desktop", width: 1440, height: 900 },
} as const satisfies Record<VisualBuilderDevice, VisualBuilderViewport>;
